import React, { useCallback, useContext, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MLEndorsementFlowUtil } from 'ml-portals-util-js';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import metadata from './YourPoliciesPage.metadata.json5';
import messages from  './YourPoliciesPage.messages';

// Base PUP Your Policies Page added to test wizard flow
function YourPoliciesPage(props) {
    const { 
        showProgressDialog,
    } = MLModalService();

    const { wizardData, updateWizardData, authHeader, goNext, steps, changeNextSteps, currentStepIndex } = props;
    const { submissionVM } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const onNext = useCallback(() => {
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            return;
        }

        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.savingPolicyChange, promise);
        promise.then((updatedPolicyChange) => {
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            updateWizardSubmissionData(updatedEndorsementVM);
            goNext();
        });
    }, [submissionVM, EndorsementService, authHeader, showProgressDialog, viewModelService, updateWizardSubmissionData, goNext]);

    const overrideProps = {
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        }
    };


    useEffect(() => {
        MLEndorsementFlowUtil.startingPointPageLoadIsSkipping(submissionVM, goNext, steps, currentStepIndex, changeNextSteps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
            policyChangePageHeaderML={messages.makeChanges}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

YourPoliciesPage.propTypes = wizardProps;
export default withAuthenticationContext(YourPoliciesPage);
